import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateStringComponent } from './translate-string.component';

@NgModule({
  imports: [CommonModule],
  declarations: [TranslateStringComponent],
  exports: [TranslateStringComponent],
})
export class TranslateStringsModule {}
